"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@/state/globalStore";
import { type PostSituationRequest } from "@/generated/fastapi";
import { postSituation } from "../api/postSituation";
import { situationsKeys } from "../queries/keys";

export default function useCreateSituationMutation() {
  const queryClient = useQueryClient();
  const { accessToken } = useAuth();

  return useMutation({
    mutationFn: (request: PostSituationRequest) =>
      postSituation(accessToken, request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: situationsKeys.all });
    },
  });
}
